import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import store from '@vuex/store.js';
import requests from '@/vuex/requests.js';

export const queries = createQueryKeyStore({
  workspace: {
    all: null,
    current: {
      queryKey: null,
      queryFn: async () => {
        const workspaceId = store.getters['workspace/getId'];
        const data = await requests.workspaces.load(workspaceId);
        store.dispatch('workspace/setWorkspace', { value: data });
        return data;
      },
    },
    connections: {
      queryKey: null,
      queryFn: async () => {
        const data = await requests.me.workspaceConnections(
          store.getters['workspace/getId']
        );
        await Promise.all([
          store.dispatch('user/setCurrentMembership', {
            value: data.currentMembership,
          }),
          store.dispatch('user/setExternalMemberships', {
            value: data.externalMemberships,
          }),
          store.dispatch('user/setMemberships', { value: data.memberships }),
        ]);
        return data;
      },
    },
    invitations: ({ status = null } = {}) => ({
      queryKey: [{ status }],
      queryFn: () =>
        requests.invitations.get(store.getters['workspace/getId'], { status }),
    }),
    members: {
      queryKey: null,
      queryFn: () =>
        requests.workspaces.members(store.getters['workspace/getId']),
    },
    externalUsers: {
      queryKey: null,
      queryFn: () =>
        requests.workspaces.externalUsers.list(
          store.getters['workspace/getId']
        ),
    },
    projects: {
      queryKey: null,
      queryFn: () =>
        requests.workspaces.projects.list({
          workspaceId: store.getters['workspace/getId'],
        }),
    },
    roles: {
      queryKey: null,
      queryFn: () => requests.roles.get(store.getters['workspace/getId']),
    },
  },
  project: {
    externalUsers: hash => ({
      queryKey: [hash],
      queryFn: async () => {
        const data = await requests.projects.listExternalUsers({ hash });
        store.commit('project/setExternalUsers', { value: data });
        return data;
      },
    }),
    pendingInvitations: hash => ({
      queryKey: [hash],
      queryFn: async () => requests.projects.pendingInvitations({ hash }),
    }),
  },
  permissions: {
    workspace: workspaceId => ({
      queryKey: [workspaceId],
      queryFn: async () => {
        const data = await requests.permissions.current({
          workspaceId: workspaceId.value,
        });
        store.dispatch('permissions/setPermissions', data);
        return data;
      },
    }),
    project: hash => ({
      queryKey: [hash],
      queryFn: async () => {
        const data = await requests.permissions.current({ projectHash: hash });
        store.dispatch('permissions/setPermissions', data);
        return data;
      },
    }),
  },
  features: {
    workspace: workspaceId => ({
      queryKey: [workspaceId],
      queryFn: async () => {
        const data = await requests.features.current({
          workspaceId: workspaceId.value,
        });
        await store.dispatch('features/setFeatures', { features: data });
        return data;
      },
    }),
    project: hash => ({
      queryKey: [hash],
      queryFn: async () => {
        const data = await requests.features.current({ projectHash: hash });
        store.dispatch('features/setFeatures', { features: data });
        return data;
      },
    }),
  },
});
